import React, { Component, lazy, Suspense } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router";
import { ConfirmProvider } from "material-ui-confirm";

import { Layout } from "components/Layout";

//import { ForgotPasswordPage } from "pages/ForgotPasswordPage";
//import { ResetPasswordPage } from "pages/ResetPasswordPage";
//import { ConfirmEmailPage } from "pages/ConfirmEmailPage";

import { Provider } from "react-redux";
import { store } from "stores/store";
import { PONERA_ROUTES } from "routes";

import { PageWithMenu } from "components/Layout/PageWithMenu";

//import { UnauthorizedPage } from "pages/UnauthorizedPage";
import RequireAuth from "components/RequireAuth";
import RequireNoAuth from "components/RequireNoAuth";

import CardProvider from "components/Layout/CardContext";
import { HelpProvider } from "components/Help/HelpContext";
import { FooterProvider } from "components/Footer/FooterContext";

import "styles/scss/style.scss";

const StringResourcesPage = lazy(() => import("pages/StringResourcesPage"));
const CompaniesPage = lazy(() => import("pages/CompaniesPage"));
const UsersPage = lazy(() => import("pages/UsersPage"));
const LoginPage = lazy(() => import("pages/LoginPage"));
const ConfigPage = lazy(() => import("pages/ConfigPage"));
const FeedbackPage = lazy(() => import("pages/FeedbackPage"));
const ForgotPasswordPage = lazy(() => import("pages/ForgotPasswordPage"));
const SignUpPage = lazy(() => import("pages/SignUpPage"));
const ResetPasswordPage = lazy(() => import("pages/ResetPasswordPage"));
const ConfirmEmailPage = lazy(() => import("pages/ConfirmEmailPage"));
const PackagingPage = lazy(() => import("pages/Packaging"));
const DashboardPage = lazy(() => import("pages/DashboardPage"));
const SopMatrix = lazy(() => import("pages/SOPMatrix"));
const SustainabilityPage = lazy(() => import("pages/Sustainability"));

const ROLES = {
  User: "Operator",
  PoneraAdmin: "Ponera_Admin",
  CompanyAdmin: "Company_Admin",
};

const MODULES = {
  Packaging: "Packaging",
  Sustainability: "Sustainability",
  Transparency: "Transparency",
};

function App(Component) {
  const InjectedTodos = function (props) {
    let location = useLocation();

    return <AppInner {...props} location={location} />;
  };
  return InjectedTodos;
}

function AppInner(props) {
  let location = props.location;

  return (
    <Provider store={store}>
      <HelpProvider>
        <FooterProvider>
          <CardProvider>
            <ConfirmProvider>
              <Layout location={location}>
                <Routes location={location}>
                  <Route
                    path="/admin"
                    element={<RequireAuth allowedRoles={[ROLES.PoneraAdmin]} />}
                  >
                    <Route
                      path={""}
                      element={<PageWithMenu ContestoApp="uman" />}
                    >
                      <Route
                        path={PONERA_ROUTES.ADMIN.SOPMATRIX}
                        element={<SopMatrix />}
                      />
                    </Route>
                  </Route>

                  <Route
                    path="/admin"
                    element={
                      <RequireAuth
                        allowedRoles={[ROLES.CompanyAdmin, ROLES.PoneraAdmin]}
                      />
                    }
                  >
                    <Route
                      path={""}
                      element={<PageWithMenu ContestoApp="uman" />}
                    >
                      <Route
                        path={PONERA_ROUTES.ADMIN.STRINGRESOURCES}
                        element={<StringResourcesPage />}
                      />

                      <Route
                        path={PONERA_ROUTES.ADMIN.COMPANIES}
                        element={<CompaniesPage />}
                      />

                      <Route
                        path={PONERA_ROUTES.ADMIN.CONFIG}
                        element={<ConfigPage />}
                      />

                      <Route
                        path={PONERA_ROUTES.ADMIN.USERS}
                        element={<UsersPage />}
                      />
                      <Route
                        path={PONERA_ROUTES.ADMIN.FEEDBACK}
                        element={<FeedbackPage />}
                      />
                    </Route>
                  </Route>

                  <Route path="/" element={<RequireNoAuth />}>
                    <Route path={PONERA_ROUTES.LOGIN} element={<LoginPage />} />
                    <Route
                      path={PONERA_ROUTES.SIGN_UP}
                      element={<SignUpPage />}
                    />
                    <Route
                      path={PONERA_ROUTES.FORGOT_PASSWORD}
                      element={<ForgotPasswordPage />}
                    />
                    <Route
                      path={PONERA_ROUTES.RESET_PASSWORD}
                      element={<ResetPasswordPage />}
                    />
                    <Route
                      path={PONERA_ROUTES.CONFIRM_EMAIL}
                      element={<ConfirmEmailPage />}
                    />
                    <Route
                      path={"/"}
                      element={
                        <>
                          <Suspense fallback={<div>Loading...</div>}>
                            <DashboardPage />
                          </Suspense>
                          <PageWithMenu ContestoApp="dashboard" />
                        </>
                      }
                    />
                  </Route>

                  <Route
                    path="/packaging"
                    element={
                      <RequireAuth
                        allowedModules={[MODULES.Packaging]}
                        allowedRoles={[ROLES.CompanyAdmin, ROLES.User]}
                      />
                    }
                  >
                    <Route
                      path={""}
                      element={<PageWithMenu ContestoApp="packaging" />}
                    >
                      <Route path={""} element={<PackagingPage />} />
                    </Route>
                  </Route>

                  <Route
                    path="/Sustainability"
                    element={
                      <RequireAuth
                        allowedModules={[MODULES.Sustainability]}
                        allowedRoles={[ROLES.CompanyAdmin, ROLES.User]}
                      />
                    }
                  >
                    <Route
                      path={""}
                      element={<PageWithMenu ContestoApp="Sustainability" />}
                    >
                      <Route path={""} element={<SustainabilityPage />} />
                    </Route>
                  </Route>

                  <Route
                    path={PONERA_ROUTES.DASHBOARD}
                    element={
                      <>
                        <Suspense fallback={<div>Loading...</div>}>
                          <DashboardPage />
                        </Suspense>
                        <PageWithMenu ContestoApp="dashboard" />
                      </>
                    }
                  />
                </Routes>
              </Layout>
            </ConfirmProvider>
          </CardProvider>
        </FooterProvider>
      </HelpProvider>
    </Provider>
  );
}

export default App(AppInner);
